import { NavLink, useLocation } from 'react-router-dom'
import { useAuth, isTeenAccount } from '../context/AuthContext'
import { useUnreadMessages } from '../context/UnreadMessagesContext'

function ActivityIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
    </svg>
  )
}

function SearchIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  )
}

function WriteIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z" />
    </svg>
  )
}

function MessageIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22z" />
    </svg>
  )
}

function UserIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  )
}

const HIDDEN_PATHS = ['/write', '/login', '/signup']

export default function BottomNav() {
  const { user, profile } = useAuth()
  const location = useLocation()
  const unread = useUnreadMessages()
  // PR 2: profile.username is server-authoritative; email fallback covers the
  // pre-fetch window.
  const username = profile?.username ?? user?.email?.split('@')[0] ?? ''

  if (!user) return null
  if (HIDDEN_PATHS.some(p => location.pathname.startsWith(p))) return null

  return (
    <nav className="bottom-nav">
      <NavLink to="/activity" className={({ isActive }) => `bottom-nav__tab bottom-nav__tab--activity${isActive ? ' bottom-nav__tab--active' : ''}`}>
        <span className="bottom-nav__icon"><ActivityIcon /></span>
        <span className="bottom-nav__label">Activity</span>
      </NavLink>
      <NavLink to="/browse" className={({ isActive }) => `bottom-nav__tab bottom-nav__tab--browse${isActive ? ' bottom-nav__tab--active' : ''}`}>
        <span className="bottom-nav__icon"><SearchIcon /></span>
        <span className="bottom-nav__label">Browse</span>
      </NavLink>
      <NavLink to="/write" className={({ isActive }) => `bottom-nav__tab bottom-nav__tab--write${isActive ? ' bottom-nav__tab--active' : ''}`}>
        <span className="bottom-nav__icon"><WriteIcon /></span>
        <span className="bottom-nav__label">Write</span>
      </NavLink>
      {!isTeenAccount(profile) && (
        <NavLink to="/messages" className={({ isActive }) => `bottom-nav__tab bottom-nav__tab--messages${isActive ? ' bottom-nav__tab--active' : ''}`}>
          <span className="bottom-nav__icon">
            <MessageIcon />
            {unread > 0 && <span className="bottom-nav__badge" />}
          </span>
          <span className="bottom-nav__label">Messages</span>
        </NavLink>
      )}
      <NavLink to={username ? `/user/${username}` : '/'} className={({ isActive }) => `bottom-nav__tab bottom-nav__tab--profile${isActive ? ' bottom-nav__tab--active' : ''}`}>
        <span className="bottom-nav__icon"><UserIcon /></span>
        <span className="bottom-nav__label">Profile</span>
      </NavLink>
    </nav>
  )
}
